import { Component, inject } from '@angular/core';
import { ShiftService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ShiftCreateDto,
  ShiftDto,
  ShiftExcelDownloadDto,
  ShiftUpdateDto,
} from '../proxy/controlling/dtos/shift';
import { SHIFT_CONFIG, SHIFT_FIELDS } from './shift.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-shift',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ShiftService, ConfirmationService],
  templateUrl: './shift.html',
  styleUrl: './shift.scss',
})
export class Shift extends BaseCrudComponent<
  ShiftDto,
  ShiftCreateDto,
  ShiftUpdateDto,
  ShiftExcelDownloadDto
> {
  service = inject(ShiftService);
  config = SHIFT_CONFIG;
  fields = SHIFT_FIELDS;

  protected prepareUpdateDto(data: any, selected: ShiftDto): ShiftUpdateDto {
    return {
      name: data.name,
      code: data.code,
      startHour: data.startHour,
      endHour: data.endHour,
      isVisibleInMobile: data.isVisibleInMobile,
      isNocturnal: data.isNocturnal,
      isProductive: data.isProductive,
      breakTime: data.breakTime,
      vendorId: data.vendorId,
      shiftGroupId: data.shiftGroupId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Shift';
  }
}
